import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { SharedModule } from 'src/app/shared/shared.module';
import { DealershipRoutingModule } from './dealership.routing';
import { DealershipFormComponent } from './components/dealership-form/dealership-form.component';
import { ListDealershipComponent } from './list-dealership/list-dealership.component';
import { CreateDealershipComponent } from './create-dealership/create-dealership.component';
import { UpdateDealershipComponent } from './update-dealership/update-dealership.component';
import { ImportDealershipComponent } from './import-dealership/import-dealership.component';
import { ExportDealershipComponent } from './export-dealership/export-dealership.component';

@NgModule({
  declarations: [
    ListDealershipComponent,
    DealershipFormComponent,
    CreateDealershipComponent,
    UpdateDealershipComponent,
    ImportDealershipComponent,
    ExportDealershipComponent
  ],
  imports: [NgxMaskDirective, SharedModule, RouterLink, DealershipRoutingModule],
  providers: [provideNgxMask()]
})
export class DealershipModule {}
